export default "/static/images/middle_1.png?8cea400fb379c7386344c0c57d0af9ed";